module.exports = __webpack_public_path__ + "img/menu-on_04.d93c1bae.png";